module.exports = __webpack_public_path__ + "img/setup-2.f19cdabf.webp";